import { useEffect, useMemo, useState } from "react";
import { PackagesAPI, ServicesAPI } from "../api";

export default function AdminPackages() {
  const [items, setItems] = useState([]);
  const [services, setServices] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [creating, setCreating] = useState(false);
  const [autoEditId, setAutoEditId] = useState(null);
  const [form, setForm] = useState({ name: "", shortDescription: "", longDescription: "", monthlyNetPrice: "", monthsBilledPerYear: 12, note: "", active: true, isStandard: true });

  useEffect(() => {
    const load = async () => {
      try {
        setLoading(true);
        const [list, svc] = await Promise.all([
          PackagesAPI.list(),
          ServicesAPI.list(),
        ]);
        setItems(list);
        setServices(svc);
      } catch (e) {
        setError(e?.response?.data?.error || e.message);
      } finally {
        setLoading(false);
      }
    };
    load();
  }, []);

  const resetForm = () => setForm({ name: "", shortDescription: "", longDescription: "", monthlyNetPrice: "", monthsBilledPerYear: 12, note: "", active: true, isStandard: true });

  const handleCreate = async () => {
    if (!form.name.trim()) return alert("Name erforderlich");
    const payload = {
      ...form,
      monthlyNetPrice: normalizeNumber(form.monthlyNetPrice) ?? 0,
  monthsBilledPerYear: normalizeNumber(form.monthsBilledPerYear) ?? 12,
  isStandard: !!form.isStandard,
    };
    const created = await PackagesAPI.create(payload);
    setItems([created, ...items]);
    setCreating(false);
    resetForm();
  };

  const updateItem = (id, patch) => setItems(prev => prev.map(i => i.id === id ? { ...i, ...patch } : i));

  // helper to remove a package from local state
  const removeFromList = (id) => setItems(prev => prev.filter(i => i.id !== id));

  if (loading) return (
    <div className="home-page">
      <section style={{ width:'100vw', margin:0, padding:0, position:'relative', left:'-120px' }}>
        <h2 className="hero-title" style={{ textAlign: 'center', margin:'0 0 8px' }}>Abo-Pakete</h2>
        <p className="hero-desc" style={{ margin:'0 auto 24px', textAlign: 'center', maxWidth:760 }}>Pakete verwalten und Dienstleistungen zuordnen.</p>
      </section>
      <section style={{ width: '100%', maxWidth: 900, margin: '0 auto', padding: '0 16px 40px 16px', color: '#fff' }}>
        <div>Lade …</div>
      </section>
    </div>
  );
  if (error) return (
    <div className="home-page">
      <section style={{ width:'100vw', margin:0, padding:0, position:'relative', left:'-120px' }}>
        <h2 className="hero-title" style={{ textAlign: 'center', margin:'0 0 8px' }}>Abo-Pakete</h2>
        <p className="hero-desc" style={{ margin:'0 auto 24px', textAlign: 'center', maxWidth:760 }}>Pakete verwalten und Dienstleistungen zuordnen.</p>
      </section>
      <section style={{ width: '100%', maxWidth: 900, margin: '0 auto', padding: '0 16px 40px 16px', color: '#fff' }}>
        <div style={{ color: '#b00' }}>Fehler: {String(error)}</div>
      </section>
    </div>
  );

  return (
    <div className="home-page">
      {/* Outer full-width header section */}
      <section style={{ width:'100vw', margin:0, padding:0, position:'relative', left:'-120px' }}>
        <h2 className="hero-title" style={{ textAlign: 'center', margin:'0 0 8px' }}>Abo-Pakete</h2>
        <p className="hero-desc" style={{ margin:'0 auto 24px', textAlign: 'center', maxWidth:760 }}>Pakete verwalten und Dienstleistungen zuordnen.</p>
      </section>
      {/* Centered content container */}
      <section style={{ width: '100%', maxWidth: 900, margin: '0 auto', padding: '0 16px 40px 16px', color: '#fff', position:'relative', left:'-120px' }}>
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      

      {!creating ? (
        <button onClick={() => setCreating(true)} style={{ marginBottom: 16 }}>+ Neues Paket</button>
      ) : (
        <div style={{ border: "1px solid #ddd", borderRadius: 8, padding: 16, marginBottom: 24 }}>
          <h3 style={{ marginTop: 0 }}>Neues Paket anlegen</h3>
          <Grid two>
            <Text label="Name" value={form.name} onChange={v => setForm(f => ({ ...f, name: v }))} />
            <Text label="Monatspreis netto (€)" value={form.monthlyNetPrice} onChange={v => setForm(f => ({ ...f, monthlyNetPrice: v }))} placeholder="z.B. 29,90" />
            <Text label="Kurzbeschreibung" value={form.shortDescription} onChange={v => setForm(f => ({ ...f, shortDescription: v }))} />
            <Text label="Monate pro Jahr (Abrechnung)" value={form.monthsBilledPerYear} onChange={v => setForm(f => ({ ...f, monthsBilledPerYear: v }))} />
          </Grid>
          <TextArea label="Langbeschreibung" value={form.longDescription} onChange={v => setForm(f => ({ ...f, longDescription: v }))} />
          <TextArea label="Hinweis" value={form.note} onChange={v => setForm(f => ({ ...f, note: v }))} />
          <label style={{ display: "inline-flex", alignItems: "center", gap: 8, marginRight: 16 }}>
            <input type="checkbox" checked={!!form.active} onChange={e => setForm(f => ({ ...f, active: e.target.checked }))} />
            Aktiv
          </label>
          <label style={{ display: "inline-flex", alignItems: "center", gap: 8 }}>
            <input type="checkbox" checked={!!form.isStandard} onChange={e => setForm(f => ({ ...f, isStandard: e.target.checked }))} />
            Standard-Paket
          </label>
          <div style={{ display: "flex", gap: 8, marginTop: 12 }}>
            <button onClick={handleCreate}>Anlegen</button>
            <button onClick={() => { setCreating(false); resetForm(); }}>Abbrechen</button>
          </div>
        </div>
      )}

      <div style={{ display: "grid", gap: 16 }}>
        {items.map(pkg => (
          <PackageCard
            key={pkg.id}
            pkg={pkg}
            services={services}
            onPkgChange={p => updateItem(pkg.id, p)}
            onDeleted={() => removeFromList(pkg.id)}
            onDuplicated={(dup) => { setItems(prev => [dup, ...prev]); setAutoEditId(dup.id); }}
            autoEditId={autoEditId}
            onOpenedEdit={() => setAutoEditId(null)}
          />
        ))}
      </div>
      </section>
    </div>
  );
}

function PackageCard({ pkg, services, onPkgChange, onDeleted, onDuplicated, autoEditId, onOpenedEdit }) {
  const [editing, setEditing] = useState(false);
  const [saving, setSaving] = useState(false);
  const [assigning, setAssigning] = useState({ serviceId: "", quantity: "", frequency: "per_month", info: "", extraCostPossible: false });
  const [local, setLocal] = useState(pkg);

  useEffect(() => setLocal(pkg), [pkg?.id]);
  useEffect(() => {
    if (autoEditId && autoEditId === pkg.id && !editing) {
      setEditing(true);
      if (onOpenedEdit) onOpenedEdit();
      // scroll into view for convenience
      try { document.querySelector(`[data-pkg-id="${pkg.id}"]`)?.scrollIntoView({ behavior: 'smooth', block: 'center' }); } catch {}
    }
  }, [autoEditId, pkg?.id]);

  const save = async () => {
    setSaving(true);
    try {
      const payload = {
        name: local.name,
        shortDescription: local.shortDescription,
        longDescription: local.longDescription,
        note: local.note,
        active: !!local.active,
        isStandard: !!local.isStandard,
        monthlyNetPrice: normalizeNumber(local.monthlyNetPrice),
        monthsBilledPerYear: normalizeNumber(local.monthsBilledPerYear),
      };
      const res = await PackagesAPI.update(pkg.id, payload);
      onPkgChange(res);
      setEditing(false);
    } finally {
      setSaving(false);
    }
  };

  const remove = async () => {
    if (!confirm("Paket wirklich löschen?")) return;
    await PackagesAPI.remove(pkg.id);
    if (onDeleted) onDeleted();
  };

  const addService = async () => {
    if (!assigning.serviceId) return alert("Bitte Dienstleistung wählen");
    await PackagesAPI.addService(pkg.id, {
      serviceId: assigning.serviceId,
      quantity: normalizeNumber(assigning.quantity),
      frequency: assigning.frequency,
      info: assigning.info,
      extraCostPossible: !!assigning.extraCostPossible,
    });
    const fresh = await PackagesAPI.get(pkg.id);
    onPkgChange(fresh);
    setAssigning({ serviceId: "", quantity: "", frequency: "per_month", info: "", extraCostPossible: false });
  };

  const assigned = pkg.Services || [];

  // Helpers to compute annual price, package value, and savings
  const toNum = (v, fb = 0) => {
    const n = Number(v);
    return Number.isFinite(n) ? n : fb;
  };
  const annualPrice = () => {
    const perMonth = toNum(pkg.monthlyNetPrice, 0);
    const months = toNum(pkg.monthsBilledPerYear, 12);
    return perMonth * months;
  };
  const packageValue = () => {
    const items = assigned || [];
    let sum = 0;
    for (const s of items) {
      const price = toNum(s.netPrice, 0);
      const q = s?.PackageService?.quantity == null || s?.PackageService?.quantity === ''
        ? 1
        : toNum(s.PackageService.quantity, 1);
      const freq = s?.PackageService?.frequency || 'per_month';
      let mult = 0;
      if (freq === 'per_month') mult = 12;
      else if (freq === 'per_year') mult = 1;
      else if (freq === 'unlimited') mult = 12; // unlimited: 1x pro Monat -> 12x im Jahr
      sum += price * q * mult;
    }
    return sum;
  };
  const savings = () => {
    const ap = annualPrice();
    const val = packageValue();
    return val - ap;
  };

  return (
    <div style={{ border: "1px solid #ddd", borderRadius: 8, padding: 16 }} data-pkg-id={pkg.id}>
      {!editing ? (
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
          <div>
            <div style={{ fontSize: 18, fontWeight: 600, display:'flex', alignItems:'center', gap:8 }}>
              <span>{pkg.name}</span> {pkg.active ? "" : <span style={{ color: "#a00", fontWeight: 500 }}>(inaktiv)</span>}
              <span style={{
                fontSize: 11,
                background: pkg.isStandard ? 'rgba(46, 204, 113, 0.18)' : 'rgba(52, 152, 219, 0.18)',
                color: pkg.isStandard ? '#2ecc71' : '#3498db',
                border: `1px solid ${pkg.isStandard ? 'rgba(46,204,113,0.45)' : 'rgba(52,152,219,0.45)'}`,
                padding: '2px 6px',
                borderRadius: 8,
                fontWeight: 700
              }}>{pkg.isStandard ? 'STANDARD' : 'INDIVIDUELL'}</span>
            </div>
            <div style={{ color: "#666" }}>
              {formatPrice(pkg.monthlyNetPrice)} / Monat · Abrechnung: {pkg.monthsBilledPerYear} Monate/Jahr
            </div>
            <div style={{ color: "#888", fontSize: 13, marginTop: 4 }}>
              Jahrespreis: {formatPrice(annualPrice())} · Paketwert: {formatPrice(packageValue())} · Ersparnis: {formatPrice(savings())}
            </div>
            {pkg.shortDescription && <div style={{ marginTop: 4 }}>{pkg.shortDescription}</div>}
          </div>
          <div style={{ display: "flex", gap: 8 }}>
            <button onClick={() => setEditing(true)}>Bearbeiten</button>
            <button onClick={async () => {
              const dup = await PackagesAPI.duplicate(pkg.id);
              if (onDuplicated) onDuplicated(dup);
            }}>Duplizieren</button>
            <button onClick={remove}>Löschen</button>
          </div>
        </div>
      ) : (
        <div>
          <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 12 }}>
            <Text label="Name" value={local.name} onChange={v => setLocal(s => ({ ...s, name: v }))} />
            <Text label="Monatspreis netto (€)" value={local.monthlyNetPrice ?? ""} onChange={v => setLocal(s => ({ ...s, monthlyNetPrice: v }))} />
            <Text label="Monate pro Jahr" value={local.monthsBilledPerYear ?? 12} onChange={v => setLocal(s => ({ ...s, monthsBilledPerYear: v }))} />
            <Text label="Kurzbeschreibung" value={local.shortDescription ?? ""} onChange={v => setLocal(s => ({ ...s, shortDescription: v }))} />
          </div>
          <TextArea label="Langbeschreibung" value={local.longDescription ?? ""} onChange={v => setLocal(s => ({ ...s, longDescription: v }))} />
          <TextArea label="Hinweis" value={local.note ?? ""} onChange={v => setLocal(s => ({ ...s, note: v }))} />
          <label style={{ display: "inline-flex", alignItems: "center", gap: 8, marginRight: 16 }}>
            <input type="checkbox" checked={!!local.active} onChange={e => setLocal(s => ({ ...s, active: e.target.checked }))} />
            Aktiv
          </label>
          <label style={{ display: "inline-flex", alignItems: "center", gap: 8 }}>
            <input type="checkbox" checked={!!local.isStandard} onChange={e => setLocal(s => ({ ...s, isStandard: e.target.checked }))} />
            Standard-Paket
          </label>
          <div style={{ display: "flex", gap: 8, marginTop: 12 }}>
            <button onClick={save} disabled={saving}>Speichern</button>
            <button onClick={() => setEditing(false)}>Abbrechen</button>
          </div>
        </div>
      )}

      <div style={{ marginTop: 16 }}>
        <h4 style={{ margin: "16px 0 8px" }}>Zugeordnete Dienstleistungen</h4>
        {assigned.length === 0 ? (
          <div style={{ color: "#666" }}>Noch keine Dienstleistungen zugeordnet.</div>
        ) : (
          <div style={{ display: "grid", gap: 8 }}>
            {assigned.map(svc => (
              <AssignmentRow
                key={svc.id}
                pkgId={pkg.id}
                svc={svc}
                onChanged={async () => {
                  const fresh = await PackagesAPI.get(pkg.id);
                  onPkgChange(fresh);
                }}
              />
            ))}
          </div>
        )}
        <div style={{ borderTop: "1px dashed #ddd", marginTop: 12, paddingTop: 12 }}>
          <h5 style={{ margin: "8px 0" }}>Dienstleistung hinzufügen</h5>
          <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr 1fr auto", gap: 8 }}>
            <select value={assigning.serviceId} onChange={e => setAssigning(s => ({ ...s, serviceId: e.target.value }))}>
              <option value="">— wählen —</option>
              {services.map(s => (
                <option key={s.id} value={s.id}>{s.name}</option>
              ))}
            </select>
            <input placeholder="Menge" value={assigning.quantity} onChange={e => setAssigning(s => ({ ...s, quantity: e.target.value }))} />
            <select value={assigning.frequency} onChange={e => setAssigning(s => ({ ...s, frequency: e.target.value }))}>
              <option value="per_month">pro Monat</option>
              <option value="per_year">pro Jahr</option>
              <option value="unlimited">unbegrenzt</option>
            </select>
            <input placeholder="Info" value={assigning.info} onChange={e => setAssigning(s => ({ ...s, info: e.target.value }))} />
            <label style={{ display: "inline-flex", alignItems: "center", gap: 6 }}>
              <input type="checkbox" checked={assigning.extraCostPossible} onChange={e => setAssigning(s => ({ ...s, extraCostPossible: e.target.checked }))} />
              Mehrkosten möglich
            </label>
            <button onClick={addService}>Hinzufügen</button>
          </div>
        </div>
      </div>
    </div>
  );
}

function AssignmentRow({ pkgId, svc, onChanged }) {
  const [local, setLocal] = useState({
    quantity: svc.PackageService?.quantity ?? "",
    frequency: svc.PackageService?.frequency ?? "per_month",
    info: svc.PackageService?.info ?? "",
    extraCostPossible: !!svc.PackageService?.extraCostPossible,
  });
  const [saving, setSaving] = useState(false);

  const save = async () => {
    setSaving(true);
    try {
      await PackagesAPI.updateService(pkgId, svc.id, {
        quantity: normalizeNumber(local.quantity),
        frequency: local.frequency,
        info: local.info,
        extraCostPossible: !!local.extraCostPossible,
      });
      await onChanged();
    } finally {
      setSaving(false);
    }
  };

  const remove = async () => {
    if (!confirm("Zuweisung entfernen?")) return;
    await PackagesAPI.removeService(pkgId, svc.id);
    await onChanged();
  };

  return (
    <div style={{ display: "grid", gridTemplateColumns: "2fr 1fr 1fr 2fr auto auto", alignItems: "center", gap: 8 }}>
      <div style={{ fontWeight: 600 }}>{svc.name}</div>
      <input placeholder="Menge" value={local.quantity ?? ""} onChange={e => setLocal(s => ({ ...s, quantity: e.target.value }))} />
      <select value={local.frequency} onChange={e => setLocal(s => ({ ...s, frequency: e.target.value }))}>
        <option value="per_month">pro Monat</option>
        <option value="per_year">pro Jahr</option>
        <option value="unlimited">unbegrenzt</option>
      </select>
      <input placeholder="Info" value={local.info ?? ""} onChange={e => setLocal(s => ({ ...s, info: e.target.value }))} />
      <label style={{ display: "inline-flex", alignItems: "center", gap: 6 }}>
        <input type="checkbox" checked={!!local.extraCostPossible} onChange={e => setLocal(s => ({ ...s, extraCostPossible: e.target.checked }))} />
        Mehrkosten
      </label>
      <div style={{ display: "flex", gap: 8 }}>
        <button onClick={save} disabled={saving}>Speichern</button>
        <button onClick={remove}>Entfernen</button>
      </div>
    </div>
  );
}

function Grid({ two, children }) {
  return <div style={{ display: "grid", gridTemplateColumns: two ? "1fr 1fr" : "1fr", gap: 12 }}>{children}</div>;
}
function Text({ label, value, onChange, placeholder }) {
  return (
    <label style={{ display: "grid", gap: 4 }}>
      <span style={{ color: "#444" }}>{label}</span>
      <input value={value ?? ""} placeholder={placeholder} onChange={e => onChange(e.target.value)} />
    </label>
  );
}
function TextArea({ label, value, onChange }) {
  return (
    <label style={{ display: "grid", gap: 4 }}>
      <span style={{ color: "#444" }}>{label}</span>
      <textarea rows={4} value={value ?? ""} onChange={e => onChange(e.target.value)} />
    </label>
  );
}

function formatPrice(n) {
  if (n == null) return "—";
  const v = Number(n);
  if (!isFinite(v)) return String(n);
  return v.toFixed(2).replace(".", ",") + " €";
}
function normalizeNumber(v) {
  if (v === null || v === undefined || v === "") return null;
  const n = Number(String(v).replace(",", "."));
  return isFinite(n) ? n : null;
}
